// extracted by mini-css-extract-plugin
export var dropdown = "_k2-0";
export var imagePlaceholder = "_k2-2";
export var imageWrapper = "_k2-3";
export var productImage = "_k2-1";
export var truncateContainer = "_k2-4";
export var truncateText = "_k2-5";